module.exports = __webpack_public_path__ + "img/bytedance-propa.5a05e96c.png";